<template>
    <div class="container-fluid forms-search-container">
        <div class="row">
            <div class="col-12" />
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <form
                            action=""
                            @submit.prevent="searchFormSubmit()"
                            class="form-inline"
                        >
                            <div class="input-group col-12 col-md-4">
                                <input
                                    type="search"
                                    name="keyword"
                                    id="keyword"
                                    placeholder="Search..."
                                    v-model.lazy="keyword"
                                    class="form-control"
                                    @input="searchFormSubmit"
                                >
                            </div>
                            <div class="input-group col-12 col-md-4">
                                <select
                                    name="type"
                                    v-model="type"
                                    placeholder="Type"
                                    class="form-control"
                                    @change="searchFormSubmit"
                                >
                                    <option :value="null">
                                        All Types
                                    </option>
                                    <option
                                        v-for="t in types"
                                        :value="t.value"
                                        :key="t.value"
                                    >
                                        {{ t.name }}
                                    </option>
                                </select>
                            </div>
                            <button class="btn btn-primary mr-sm-2">
                                <i class="fa fa-search" /> Search
                            </button>
                            <button
                                class="btn btn-success mr-sm-2"
                                type="button"
                                @click.prevent="newForm()"
                            >
                                <i class="fa fa-plus" /> New Form
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <table
                            class="table"
                            v-if="forms.length"
                            :class="{disabled: loading}"
                        >
                            <thead>
                                <tr>
                                    <th>Doc No.</th>
                                    <th>Type</th>
                                    <th>Customer</th>
                                    <th>Updated</th>
                                    <th>Sent At</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(form, index) in forms"
                                    :key="index"
                                >
                                    <td>
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                        >
                                            {{ form.doc_no || '-' }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                        >
                                            {{ form.nice_type }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <span v-if="form.customer">
                                            <router-link
                                                :to="{name: 'office.customers.show', params: { id: form.customer_id }}"
                                                title="View Customer"
                                            >
                                                {{ form.customer.company_name }}
                                                <i
                                                    class="fas fa-external-link-alt"
                                                    style="font-size: .8em; margin-left: .5em"
                                                />
                                            </router-link>

                                        </span>
                                        <span v-if="!form.customer">-</span>
                                    </td>
                                    <td>
                                        {{ form.updated_at | datetime }}
                                    </td>
                                    <td>
                                        {{ form.sent_at | datetime }}
                                    </td>
                                    <td class="text-right">
                                        <router-link
                                            :to="{name: 'office.forms.edit', params: { id: form.id }}"
                                            title="Edit Form"
                                            class="row-icon"
                                        >
                                            <i class="fa fa-pencil-alt" />
                                        </router-link>
                                        <a
                                            v-if="form.id"
                                            :href="'/api/forms/' + form.id + '/stream'"
                                            class="row-icon"
                                            title="Print Preview"
                                            target="_blank"
                                        >
                                            <i class="fa fa-print" />
                                        </a>

                                        <a
                                            v-if="form.id"
                                            :href="'/api/forms/' + form.id + '/download'"
                                            class="row-icon"
                                            target="_blank"
                                            title="Download PDF"
                                        >
                                            <i class="fa fa-download" />
                                        </a>
                                        <router-link
                                            v-if="form.id"
                                            :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                                            title="Send to Customer"
                                            class="row-icon"
                                        >
                                            <i class="fa fa-envelope" />
                                        </router-link>

                                        <activity-log
                                            v-if="form.id"
                                            :id="form.id"
                                            model="Form"
                                            button-class="bg-transparent row-icon border-0 text-primary"
                                            small
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination
                            :page="page"
                            :last-page="lastPage"
                            @pageChange="pageChange"
                        />
                        <span
                            class="pagination-stats"
                            v-if="total > 0"
                        >Showing {{ from }} - {{ to }} out of {{ total }}</span>
                        <span v-if="!forms.length && !loading">No forms to show</span>
                        <i
                            class="fa fa-spinner fa-pulse mb-2 mr-sm-2"
                            v-if="loading"
                        />
                    </div>
                </div>
            </div>
        </div>
        <new-form-modal ref="newFormModal" />
    </div>
</template>

<script>
import FormService from "../../services/FormService";
import NewFormModal from "../forms/NewFormModal.vue";
import AuthService from "../../services/AuthService";
import Pagination from "../PaginationComponent.vue";
import * as Form from "../../include/Form";
import _ from 'lodash';
import UsesErrors from '../../mixins/UsesErrors';

export default {
    components: {
        'new-form-modal': NewFormModal,
        pagination: Pagination
    },
    mixins: [UsesErrors],
    data: function () {
        return {
            forms: [],
            loading: false,
            token: null,
            lastPage: 1,
            perPage: 50,
            from: 1,
            to: 1,
            total: 0,
            types: Form.types,
        };
    },
    computed: {
        keyword: {
            get() {
                return this.$route.query.keyword || '';
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    keyword: value,
                }});
            }
        },
        type: {
            get() {
                return this.$route.query.type || null;
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    type: value,
                }});
            }
        },
        page: {
            get() {
                return parseInt(this.$route.query.page || '1');
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    page: value,
                }});
            }
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.searchForms();
            },
        }
    },
    mounted: function () {
    },
    methods: {
        searchFormSubmit: _.debounce(function() {
            this.page = 1;
        }, 500),
        searchForms: function () {
            this.loading = true;
            FormService.search({
                page: this.page,
                keyword: this.keyword,
                type: this.type,
            }).then(
                res => {
                    this.forms = res.data.data;
                    this.lastPage = res.data.last_page;
                    this.perPage = res.data.per_page;
                    this.total = res.data.total;
                    this.from = res.data.from;
                    this.to = res.data.to;
                    this.loading = false;
                },
                err => {
                    this.loading = false;
                    this.setErrorMessage("Error: Could not load forms");
                    console.error(err);
                }
            );
        },
        pageChange: function(page) {
            this.page = page;
        },
        newForm: function () {
            this.$refs.newFormModal.show();
        },
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/SearchComponent.vue